import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  `inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2`,
  {
    variants: {
      variant: {
        default: `border-transparent bg-primary text-primary-foreground hover:bg-primary/80`,
        secondary: `border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80`,
        destructive: `border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80`,
        outline: `text-foreground border-gray-200`,
        error: `border-red-200 bg-red-50 text-red-400`,
        warning: `border-yellow-200 bg-yellow-50 text-yellow-400`,
        info: `border-blue-200 bg-blue-50 text-blue-400`,
        success: `border-green-300 bg-green-50 text-green-600`,
        disabled: `border-gray-300 bg-gray-50 text-gray-400`,
      },
      size: {
        sm: `text-xs px-1.5 py-0.5`,
        md: `text-xs px-2 py-1.5`,
        lg: `text-sm px-3 py-2`,
      },
    },
    defaultVariants: {
      variant: `default`,
      size: `md`,
    },
  }
)

export type BadgeVariant = VariantProps<typeof badgeVariants>["variant"]

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = ({ className, variant, size, ...props }: BadgeProps) => (
  <div className={cn(badgeVariants({ variant, size }), className)} {...props} />
)

// eslint-disable-next-line react-refresh/only-export-components
export { Badge, badgeVariants }
